var Backbone = require('backbone');
var _ = require('underscore');
require('jquery-ui');

var dispatcher = require('../dispatcher');

var settingsScreenTpl = require('../templates/settings-screen.jade');

module.exports = Backbone.View.extend({
	events: {
		'click .overlay': 'remove',
		'click .save': 'saveData',
		'click .reset': 'resetData'
	},
	autoRender: true,
	initialize: function () {

		_.bindAll(this, 'setData', 'saveData');

		if (this.autoRender) this.render();
	},
	render: function () {

		this.setElement(settingsScreenTpl());

		this.setData();

		this.$el.draggable();
		
		return this;
	},
	setData: function () {
		this.data = JSON.parse(localStorage.getItem('capNsub-settings'));

		_.each(this.data, _.bind(function (obj, prop) {
			if (typeof obj === 'object') {
				this.$('[name="' + prop + '"]').val(obj.value);
				obj.value = obj.value ? obj.value : 0;

				if (prop == 'player-ss' && !this.data['player-fs'].value) {
					this.data['player-fs'].value = parseInt(obj.value) + 20;
					this.$('[name="player-fs"]').val(this.data['player-fs'].value);
				}
				if (prop == 'sub-position-ss' && !this.data['sub-position-fs'].value) {
					this.data['sub-position-fs'].value = parseInt(obj.value) + 70;
					this.$('[name="sub-position-fs"]').val(this.data['sub-position-fs'].value);
				}
			} else {
				this.$('[name="' + prop + '"][value="' + obj + '"]').prop('checked', true);
			}

		}, this));
	},
	saveData: function () {
		this.$('input[type="text"], input[type="radio"]:checked').each(_.bind(function (index, el) {
			var $this = $(el);

			if ($this.attr('type') == 'radio') 
				this.data[$this.attr('name')] = $this.val();
			else 
				this.data[$this.attr('name')].value = $this.val();
		}, this));

		localStorage.removeItem('capNsub-settings');
		localStorage.setItem('capNsub-settings', JSON.stringify(this.data));

		dispatcher.emit(dispatcher.events.BUILD_SETTINGS_CSS);
		this.remove();
	},
	resetData: function () {
		dispatcher.emit(dispatcher.events.RESET_SETTINGS_CSS);
		this.setData();
	}
});


// WEBPACK FOOTER //
// ./app/views/settings-screen.js